import { Badge, CustomCellProperties } from 'alurkerja-ui';
import moment from 'moment';

export default function TableRequestCell({ name, value, defaultCell }: Readonly<CustomCellProperties>) {
  if (name === 'name' || name === 'state') {
    return <Badge content={value} color="orange" />;
  }

  if (name === 'start_time' || name === 'end_time') {
    if (!value) {
      return <>-</>;
    }
    return <span>{moment.utc(value).local().format('DD MMMM YYYY HH:mm')} WIB</span>;
  }

  if (name === 'duration') {
    if (!value) {
      return <>-</>;
    }
    return <span>{formatDuration(value)}</span>;
  }

  return defaultCell;
}

const formatDuration = (totalMilliseconds: number): string => {
  const units = [
    { label: 'year', value: 365 * 24 * 60 * 60 * 1000 },
    { label: 'month', value: 30 * 24 * 60 * 60 * 1000 },
    { label: 'day', value: 24 * 60 * 60 * 1000 },
    { label: 'hour', value: 60 * 60 * 1000 },
    { label: 'minute', value: 60 * 1000 },
    { label: 'second', value: 1000 }
  ];

  let remaining = Math.floor(totalMilliseconds);
  const parts: string[] = [];

  for (const { label, value } of units) {
    const amount = Math.floor(remaining / value);
    if (amount > 0) {
      parts.push(`${amount} ${label}${amount > 1 ? 's' : ''}`);
      remaining %= value;
    }
    if (parts.length === 3) break; // only top 3 units
  }

  return parts.length > 0 ? parts.join(' ') : '-';
};